jQuery(document).ready(function($) {

  /*
  * jQuery throttle / debounce - v1.1 - 3/7/2010
  * http://benalman.com/projects/jquery-throttle-debounce-plugin/
  * 
  * Copyright (c) 2010 "Cowboy" Ben Alman
  * Dual licensed under the MIT and GPL licenses.
  * http://benalman.com/about/license/
  */
  function st_throttle(e,f,j,i){var c=undefined;var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g}

  /*
  $(window).on('scroll', st_throttle(500, function() {
    console.log('do something');
  }));
  */

  /* MODAAL FUNCTIONALITY --------------------------------------- */
  $('a.modaal-video').modaal({
    type: 'video'
  });

  
  /* NAVIGATION ------------------------------------------------- */
  $('#navigation').each(function() {

    // Create variable for container element
    var $navigation = $(this);

    // Handle no-link menu items
    $('> ul.menu', $navigation).each(function() {

      // Create variable for the main navigation menu
      var $menu = $(this);

      // Handle items with no-link
      $('li.no-link', $menu).each(function() {

        // Create variable to contain the text of the item
        var element_text = $('> a', this).text();

        $('> a', this).detach();
        $(this).removeClass('no-link').prepend('<span class="no-link">'+element_text+'</span>');

      });

    });

    // Configure the mobile menu
    var mmenu = new Mmenu( '#navigation', {
      'offCanvas': {
        'position': 'right-front'
      },
      'navbar': false,
      'navbars': [
        {
          'use': true,
          'position': 'top',
          'content': [
            'prev',
            'title',
            'close'
          ]
        }
      ]
    },{
      'offCanvas': {
        'clone': true
      }
    });

    // Utilize mmenu API to use independent mobile menu trigger
    var mmenu_api = mmenu.API;
    $('#mm-trigger').on('click', function() {
      if ($('body').hasClass('mm-wrapper--opened')) {
        mmenu_api.close();
      } else {
        mmenu_api.open();
      }
    });

    // Handle creation of mega menu
    $('> .menu > li', $navigation).each(function() {

      var $main_nav_section = $(this);
      
      $('> ul.sub-menu', $main_nav_section).each(function() {

        // Set default drop-down tagline
        var menu_tagline = "JFSA helps individuals and families with solutions to face life's challenges with confidence.";

        // Check for tagline in element at bottom of the page
        $('#menu-tagline').each(function() {

          // Set the new value for the tagline
          menu_tagline = $(this).data('tagline');

        })

        // Create variable for sub-menu
        var $sub_menu = $(this);

        // Detach existing li elements
        var $sub_menu_content = $('> li', $sub_menu).detach();

        // Insert new structure: ul.sub-menu (flex/rows) > li (x4 columns)
        var $base_structure = $(`<li class="image"></li><li class="content"><ul><li class="intro">${menu_tagline}</li><li class="col-1 parent"><ul></ul></li><li class="col-2 parent"><ul></ul></li><li class="col-3 parent"><ul></ul></li></ul></li>`);
        $sub_menu.html($base_structure);

        $sub_menu_content.each(function(e) {

          var $content_item = $(this);

          if ($main_nav_section.hasClass('get-help')) {
            if ($content_item.hasClass('col-1')) {
              $('.col-1.parent > ul', $sub_menu).append($content_item);
            } else if ($content_item.hasClass('col-2')) {
              $('.col-2.parent > ul', $sub_menu).append($content_item);
            } else if ($content_item.hasClass('col-3')) {
              $('.col-3.parent > ul', $sub_menu).append($content_item);
            }
          } else if ($main_nav_section.hasClass('get-involved')) {
            if ($content_item.hasClass('col-1')) {            
              $('.col-1.parent > ul', $sub_menu).append($content_item);
            } else if ($content_item.hasClass('col-2')) {
              $('.col-2.parent > ul', $sub_menu).append($content_item);
            } else if ($content_item.hasClass('col-3')) {
              $('.col-3.parent > ul', $sub_menu).append($content_item);
            }
          } else if ($main_nav_section.hasClass('get-info')) {
            if ($content_item.hasClass('col-1')) {
              $('.col-1.parent > ul', $sub_menu).append($content_item);
            } else if ($content_item.hasClass('col-2')) {
              $('.col-2.parent > ul', $sub_menu).append($content_item);
            } else if ($content_item.hasClass('col-3')) {
              $('.col-3.parent > ul', $sub_menu).append($content_item);
            }
          }
          
        });
        
      });

    });

  });


  /* FOOTER NAVIGATION ------------------------------------------ */
  $('#footer-navigation').each(function() {

    var $navigation = $(this);

      // Handle no-link menu items
    $('> ul.menu', $navigation).each(function() {

      // Create variable for the main navigation menu
      var $menu = $(this);

      // Handle items with no-link
      $('li.no-link', $menu).each(function() {

        // Remove the stacked links heading
        if ($(this).hasClass('stacked-links')) {

          $('> a', this).detach();

        // Convert remaining items to spans
        } else {

          // Create variable to contain the text of the item
          var element_text = $('> a', this).text();

          $('> a', this).detach();
          $(this).prepend('<span>'+element_text+'</span>');

        }

      });

    });

  });


  /* TOP MEN ---------------------------------------------------- */
  $('#top-menu').each(function() {
    $('li.search > a', this).each(function() {
      var button_code = `<span class="svg-icon magnifying-glass">
      <svg data-name="Magnifying Glass" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.11 20.92" role="img" aria-label="Magnifying Glass Icon">
      <title>Magnifying Glass Icon</title>
      <ellipse class="path path-ellipse" cx="8.38" cy="8.24" rx="7.43" ry="7.29" />
      <line class="path path-line" x1="14.02" y1="13.46" x2="20.16" y2="19.97" />
      </svg>
      </span>`;
      $(this).html(button_code);
    });
  });

  /* SIDEBARS --------------------------------------------------- */
  $('.content-with-sidebar').each(function() {

    // Create variables
    var $container = $(this);
    var $columns_container = $('> .wp-block-group__inner-container > .wp-block-columns', $container);
    var $sidebar = $('.col-sidebar', $container);

    // If the sidebar contains a team member, add class so we don't completely hide the sidebar in mobile view
    if ($('.singular-sidebar-team-member', $sidebar).length > 0) {
      $columns_container.addClass('has-team-member');
    }

  });


  /* SLICK SLIDER ----------------------------------------------- */
  /* https://kenwheeler.github.io/slick/ */
  /* https://accessible360.github.io/accessible-slick/ */
  /* Note: If autoplay is set to true, a play/pause button is added by default for accessibility reasons. You can hide this by setting useAutoplayToggleButton to false, but this creates an accessibility issue in itself. */
  $('#banner-standard.slideshow').each(function() {
    
    $('.banner-slideshow', this).slick({
      arrows: false,
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 1000,
      fade: true
    });

  });


  /* SMOOTH SCROLLING ------------------------------------------- */
  $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').not('[href*="#modal"]').not('.mm-btn').not('.mm-wrapper__blocker').click(function(t){if(location.pathname.replace(/^\//,"")==this.pathname.replace(/^\//,"")&&location.hostname==this.hostname){

    var e = $(this.hash);

    // Determine the heights of possible elements on the page to take into consideration
    var header_height = 240; // Fixed headers need to be taken into consideration

    // Set header height based-on the size of the fixed header at different break points
    if ($(window).width() <= 1650 && $(window).width() > 1000) {
      header_height = 180;
    } else if ($(window).width() <= 1000 && $(window).width() > 500) {
      header_height = 155;
    } else if ($(window).width() <= 500) {
      header_height = 145;
    }

    var wpadminbar_height = ($('#wpadminbar').length > 0 ? $('#wpadminbar').innerHeight() : 0); // Height of WordPress admin bar
    var scroll_top_padding = 20; // Extra padding

    // Calculate the final offset for scrolling by removing the height of the items above (and some padding) from the total offset height
    var e_offset_top = e.offset().top - (header_height + wpadminbar_height + scroll_top_padding);

  (e=e.length?e:$("[name="+this.hash.slice(1)+"]")).length&&(t.preventDefault(),$("html, body").animate({
    scrollTop:e_offset_top
  },1e3,function(){var t=$(e);if(t.focus(),t.is(":focus"))return!1;t.attr("tabindex","-1"),t.focus()}))}});


  $('#quick-service-finder').each(function() {

    // Declare Variables
    var $form = $(this);
    var $questions = $('.question', $form);
    var $question_a = $('#question-a', $form);
    var $question_b = $('#question-b', $form);
    var $question_c = $('#question-c', $form);
    var $submit = $('input[type="submit"]', $form);
    var $reset = $('input[type="reset"]', $form);
    var $data = {};

    // Reset Questions
    function reset_question(id) {

      // Set Question
      var $question = $('#'+id, $form);

      // Disable Field
      $question.prop('disabled', true);

      // Remove Field Options
      $question.html('<option value="">- SELECT -</option>');

      // Reset Data
      $data[id] = '';

    }

    // Initialize/Reset Form
    function initialize_form() {

      // Reset Questions + Data
      reset_question('question-a');
      reset_question('question-b');
      reset_question('question-c');
      $data['destination'] = '';

      // Disable Submit Button
      $submit.prop('disabled', true);
      $reset.prop('disabled', true);
      
      // Populate Question A
      for(item in custom_search_table) {        
        $question_a.append($('<option>', {
          value: item,
          text: question_a[item]
        }));
      }

      // Enable Question A
      $question_a.prop('disabled', false);
      
      // Display Form
      $form.addClass('show');

    }

    // Check Reset Availability
    function check_reset() {

      if ($data['question-a'] == '' && $data['question-b'] == '' && $data['question-c'] == '') {
        $reset.prop('disabled', true);
      } else {
        $reset.prop('disabled', false);
      }

    }

    // Check Submit Availability
    function check_submit() {
      
      if ($data['destination'] != '') {
        $submit.prop('disabled', false);
      } else {
        $submit.prop('disabled', true);
      }
      
    }
    
    // Handle Question Changes
    function question_change(id) {

      // Set Values
      var val_a = $data['question-a'];
      var val_b = $data['question-b'];
      var val_c = $data['question-c'];

      // Handle Questions
      if (id == 'question-a') {

        // Reset Fields + Data
        reset_question('question-b');
        reset_question('question-c');
        $data['destination'] = '';

        if (val_a != '') {
      
          // Populate Question B
          for(item in custom_search_table[val_a]) {                    
            $question_b.append($('<option>', {
              value: item,
              text: question_b[item]
              }));           
          }

          // Enable Question B
          $question_b.prop('disabled', false);

        }

      } else if (id == 'question-b') {

        // Reset Fields + Data
        reset_question('question-c');
        $data['destination'] = '';

        if (val_b != '') {
      
          // Populate Question B
          for(item in custom_search_table[val_a][val_b]) {        
            $question_c.append($('<option>', {
              value: item,
              text: question_c[item]
            }));      
          }

          // Enable Question B
          $question_c.prop('disabled', false);

        }

      } else if (id == 'question-c') {

        // Reset Data
        $data['destination'] = '';
  
        if (val_c != '') {
      
          // Set Destination
          var destination = custom_search_table[val_a][val_b][val_c];
          $data['destination'] = destination;

        }

      }

      check_reset();
      check_submit();
      
    }
    
    // Handle Question Selections    
    $questions.on('change', function() {

      // Determine ID
      var id = $(this).attr('id');

      // Set Data Value
      $data[id] = $('#'+id, $form).val();

      // Trigger Question Change Function
      question_change(id);

    });
   
    // Handle Form Reset
    $reset.on('click', function() {
      initialize_form()
    });
    
    // Handle Submit Button Click
    $submit.on('click', function(e) {
      
      // Prevent Default Submission
      e.preventDefault();
      
      // Destination Info
      var destination = $data['destination'];
      
      // Set Action + Submit
      // $form.attr('action',$data['destination']).submit();      
      
      location.assign(destinations[destination][0]);
      
    });

    // Global Search Matrix
    var custom_search_table = {
      "adult": {
        "adult-with-developmental-disabilities": {
          "community-and-social-activities": "plan"
        },
        "aging": {
          "community-and-social-activities": "caring-connections",
          "counseling": "care-navigation",
          "holocaust-survivors": "holocaust-survivor-support",
          "home-care": "home-care",
          "home-cleaning": "home-cleaning",
          "home-delivered-meals": "kosher-home-delivered-meals",
          "home-health-aide": "private-duty-home-care",
          "nursing": "skilled-home-health",
          "personal-safety-fails": "lifeline-emergency-medical-alert",
          "physical-occupational-speech-therapy": "skilled-home-health",
          "transportation": "shuttle-on-the-go"
        },
        "alzheimers-or-dementia": {
          "community-resources": "alzheimers-and-dementia-caregiver-support",
          "education": "brain-health-and-wellness-speaker-series"        
        },
        "covid-flu": {
          "vaccinations": "alysons-place-medical-clinic"
        },
        "domestic-violence": {
          "counseling": "domestic-violence-services",
          "emergency-shelter": "domestic-violence-services",
          "legal-resources": "domestic-violence-services",
          "safety-planning": "domestic-violence-services",
          "support-groups": "domestic-violence-services"
        },
        "financial-distress": {
          "budgeting": "forward-focus",
          "credit-counseling": "forward-focus",
          "financial-literacy": "forward-focus"
        },
        "paying-for-college-for-a-child": {
          "college-financial-aid": "cfap"
        },
        "paying-for-household-groceries": {
          "food-pantry": "chesed-center"
        },
        "paying-for-summer-camp-for-a-child": {
          "financial-assistance": "summer-campership-program"
        },
        "imminent-homelessness": {
          "emergency-shelter": "hebrew-shelter-home",
          "financial-assistance": "forward-focus",
          "finding-employment": "forward-focus"
        },
        "mental-illness": {
          "community-and-social-activities": "plan",
          "counseling-psychiatry-or-case-management": "mental-health-services",
          "finding-maintaining-employment": "employment-services",
          "housing": "housing-and-residential-services",
          "therapy-programs": "cognitive-enhancement-therapy-cet-art-therapy"
        },
        "on-the-autism-spectrum": {
          "community-and-social-activities": "plan"
        }
      },
      "family-member": { 
        "adult-with-developmental-disabilities": {
          "community-activities": "adult-day-support",
          "community-and-social-activities": "plan",
          "finding-maintaining-employment": "employment-services",
          "housing": "housing-and-residential-services",
          "lifetime-planning": "family-advocacy",
          "special-needs-trusts": "family-advocacy"
        },
        "aging-parent-or-grandparent": {
          "alzheimers-or-dementia": "alzheimers-and-dementia-caregiver-support",
          "community-and-social-activities": "caring-connections",
          "counseling": "care-navigation",
          "holocaust-survivors": "holocaust-survivor-support",
          "home-care": "home-care",
          "home-cleaning": "home-cleaning",
          "home-delivered-meals": "kosher-home-delivered-meals",
          "home-health-aide": "private-duty-home-care",
          "nursing": "skilled-home-health",
          "personal-safety-fails": "lifeline-emergency-medical-alert",
          "physical-occupational-speech-therapy": "skilled-home-health",
          "transportation": "shuttle-on-the-go"
        },
        "loved-one-with-alzheimers-or-dementia": {
          "education": "brain-health-and-wellness-speaker-series",
          "support-groups": "caregiving-with-confidence-caregiver-support-group"
        },
        "child-with-developmental-disabilities": {
          "individual-education-plans": "family-advocacy"
        },
        "loved-one-dealing-with-domestic-violence": {
          "counseling": "domestic-violence-services",
          "emergency-shelter": "domestic-violence-services",
          "legal-resources": "domestic-violence-services",
          "safety-planning": "domestic-violence-services",
          "support-groups": "journey-to-empowerment"
        },
        "loved-one-with-mental-illness": {
          "community-and-social-activities": "plan",
          "counseling-psychiatry-or-case-management": "mental-health-services",
          "finding-maintaining-employment": "employment-services",
          "housing": "housing-and-residential-services",
          "therapy-program": "cognitive-enhancement-therapy-cet-art-therapy"
        },
        "paying-for-college-for-a-child": {
          "college-financial-aid": "cfap"
        },
        "paying-for-summer-camp-for-a-child": {
          "financial-assistance": "summer-campership-program"
        },
        "teen-child-dealing-with-teen-dating-violence": {
          "education": "know-abuse"
        },
        "young-adult-child-with-special-needs": {
          "community-and-social-activities": "horvitz-youth-ability"
        }
      },
      "professional": { 
        "domestic-violence": {
          "education": "domestic-violence-services"
        },
        "teen-dating-violence-or-bullying": {
          "education": "know-abuse"
        }
      },
      "student": { 
        "paying-for-college": {
          "college-financial-aid": "cfap"
        },
        "paying-for-summer-camp": {
          "financial-assistance": "summer-campership-program"
        },
      }
    };

    var question_a = {
      "adult": "An Adult",
      "family-member": "A Family Member",
      "professional": "A Professional",
      "student": "A Student"
    };

    var question_b = {
      "adult-with-developmental-disabilities": "Adult with Developmental Disabilities",
      "aging": "An Aging Friend",
      "aging-parent-or-grandparent": "An Aging Parent or Grandparent",
      "alzheimers-or-dementia": "Someone with Alzheimer's or Dementia",
      "child-with-developmental-disabilities": "A Child with Developmental Disabilities",
      "covid-flu": "Covid or the Flu",
      "domestic-violence": "Domestic Violence",
      "financial-distress": "Financial Distress",
      "imminent-homelessness": "Imminent Homelessness",
      "loved-one-dealing-with-domestic-violence": "Loved One Dealing With Domestic Violence",
      "loved-one-with-alzheimers-or-dementia": "Loved One With Alzheimer's or Dementia",
      "loved-one-with-mental-illness": "Loved One With Mental Illness",
      "mental-illness": "Mental Illness",
      "on-the-autism-spectrum": "Autism",
      "paying-for-college": "Paying For College",
      "paying-for-college-for-a-child": "Paying For College For A Child",
      "paying-for-household-groceries": "Paying For Household Groceries",
      "paying-for-summer-camp": "Paying For Summer Camp",
      "paying-for-summer-camp-for-a-child": "Paying For Summer Camp For A Child",
      "teen-child-dealing-with-teen-dating-violence": "Teen Child Dealing With Teen Dating or Violence",
      "teen-dating-violence-or-bullying": "Teen Dating, Violence or Bullying",
      "young-adult-child-with-special-needs": "Young Adult Child with Special Needs"
    };

    var question_c = {
      "alzheimers-or-dementia": "Alzheimer's or Dementia",
      "budgeting": "Budgeting",
      "college-financial-aid": "College Financial Aid",
      "community-activities": "Community Activities",
      "community-and-social-activities": "Community and Social Activities",
      "community-resources": "Community Resources",
      "counseling": "Counseling",
      "counseling-psychiatry-or-case-management": "Counseling, Psychiatry or Case Management",
      "credit-counseling": "Credit Counseling",
      "education": "Education",
      "emergency-shelter": "Emergency Shelter",
      "financial-assistance": "Financial Assistance",
      "financial-literacy": "Financial Literacy",
      "finding-employment": "Finding Employment",
      "finding-maintaining-employment": "Finding and Maintaining Employment",
      "finding-stable-housing": "Finding Stable Housing",
      "food-pantry": "Food Pantry",
      "holocaust-survivors": "Holocaust Survivors",
      "home-care": "Home Care",
      "home-cleaning": "Home Cleaning",
      "home-delivered-meals": "Home Delivered Meals",
      "home-health-aide": "Home Health Aide",
      "housing": "Housing",
      "individual-education-plans": "Individual Education Plans",
      "legal-resources": "Legal Resources",
      "lifetime-planning": "Lifetime Planning",
      "managing-my-bills": "Managing My Bills",
      "nursing": "Nursing",
      "personal-safety-fails": "Personal Safety Fails",
      "physical-occupational-speech-therapy": "Physical Occupational Speech Therapy",
      "safety-planning": "Safety Planning",
      "special-needs-trusts": "Special Needs Trusts",
      "summer-camp": "Summer Camp",
      "support-groups": "Support Groups",
      "therapy-programs": "Therapy Programs",
      "transportation": "Transportation",
      "vaccinations": "Vaccinations"
    }

    var destinations = {
      "adult-day-support": [
        "/get-help/achieving-potential/developmental-disability-services/adult-day-support/",
        "adult-day-support-title",
        ""
      ],
      "alysons-place-medical-clinic": [
        "/get-help/alysons-place-medical-clinic/",
        "alysons-place-medical-clinic-title",
        ""
      ],
      "alzheimers-and-dementia-caregiver-support": [
        "/get-help/caring-at-home/older-adult-services/alzheimer-dementia/",
        "alzheimers-and-dementia-caregiver-support-title",
        ""
      ],
      "brain-health-and-wellness-speaker-series": [
        "/get-info/education-support-groups/brain-health-wellness-speaker-series/",
        "brain-health-and-wellness-speaker-series-title",
        ""
      ],
      "care-navigation": [
        "/get-help/caring-at-home/older-adult-services/care-navigation/",
        "care-navigation-title",
        ""
      ],
      "caregiving-with-confidence-caregiver-support-group": [
        "/get-info/education-support-groups/caregiver-support-group/",
        "caregiving-with-confidence-caregiver-support-group-title",
        ""
      ],
      "caring-connections": [
        "/get-help/caring-at-home/older-adult-services/caring-connections/",
        "caring-connections-title",
        ""
      ],
      "cfap": [
        "/cfap",
        "College Financial Aid Program",
        ""
      ],
      "chesed-center": [
        "https://www.clevelandchesedcenter.org/",
        "Chesed Center",
        "_blank"
      ],
      "cognitive-enhancement-therapy-cet-art-therapy": [
        "/get-help/achieving-potential/mental-health-services/cognitive-enhancement-therapy-cet/",
        "cognitive-enhancement-therapy-cet-art-therapy-title",
        ""
      ],
      "domestic-violence-services": [
        "/get-help/strengthening-families/domestic-violence-services/",
        "domestic-violence-services-title",
        ""
      ],
      "employment-services": [
        "/get-help/achieving-potential/employment-services/",
        "employment-services-title",
        ""
      ],
      "family-advocacy": [
        "/get-help/achieving-potential/family-advocacy-services/",
        "family-advocacy-title",
        ""
      ],
      "forward-focus": [
        "/get-help/strengthening-families/forward-focus/",
        "forward-focus-title",
        ""
      ],
      "hebrew-shelter-home": [
        "/get-help/strengthening-families/hebrew-shelter-home/",
        "hebrew-shelter-home-title",
        ""
      ],
      "holocaust-survivor-support": [
        "/get-help/caring-at-home/older-adult-services/holocaust-survivor-support/",
        "holocaust-survivor-support-title",
        ""
      ],
      "home-care": [
        "/get-help/caring-at-home/home-care/",
        "home-care-title",
        ""
      ],
      "home-cleaning": [
        "/get-help/caring-at-home/older-adult-services/home-cleaning/",
        "home-cleaning-title",
        ""
      ],
      "horvitz-youth-ability": [
        "/get-help/achieving-potential/horvitz-youthability/",
        "horvitz-youth-ability-title",
        ""
      ],
      "housing-and-residential-services": [
        "/get-help/achieving-potential/developmental-disability-services/housing-residential-services/",
        "housing-and-residential-services-title",
        ""
      ],
      "journey-to-empowerment": [
        "/get-help/strengthening-families/domestic-violence-services/",
        "journey-to-empowerment-title",
        ""
      ],
      "know-abuse": [
        "/get-help/strengthening-families/know-abuse-teen-dating-violence-prevention/",
        "know-abuse-title",
        ""
      ],
      "kosher-home-delivered-meals": [
        "/get-help/caring-at-home/older-adult-services/kosher-home-delivered-meals/",
        "kosher-home-delivered-meals-title",
        ""
      ],
      "legal-advocacy": [
        "#",
        "legal-advocacy-title",
        ""
      ],
      "lifeline-emergency-medical-alert": [
        "/get-help/caring-at-home/older-adult-services/lifeline-emergency-medical-alert/",
        "lifeline-emergency-medical-alert-title",
        ""
      ],
      "mental-health-services": [
        "/get-help/achieving-potential/mental-health-services/",
        "Mental Health Services",
        ""
      ],
      "plan": [
        "/get-help/achieving-potential/plan-of-northeast-ohio/",
        "plan-title",
        ""
      ],
      "private-duty-home-care": [
        "/get-help/caring-at-home/home-care/private-duty-home-care/",
        "private-duty-home-care-title",
        ""
      ],
      "shuttle-on-the-go": [
        "/get-help/caring-at-home/older-adult-services/shuttle-on-the-go/",
        "shuttle-on-the-go-title",
        ""
      ],
      "skilled-home-health": [
        "/get-help/caring-at-home/home-care/skilled-home-health/",
        "skilled-home-health-title",
        ""
      ],
      "summer-campership-program": [
        "/get-help/strengthening-families/summer-campership/",
        "summer-campership-program-title",
        ""
      ]
    };

    // Initialze Form
    initialize_form();

  });

});
